import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Axios from "../../../AxiosConfig";
const ServerTable = ({ apiURL, columns, filters, hidePagination = false }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortDirection, setSortDirection] = useState("asc");
    const [sortField, setSortField] = useState("");
    const customStyles = {
        headRow: {
            style: {
                border: 'none',
            },
        },
        headCells: {
            style: {
                color: '#202124',
                fontSize: '14px',
            },
        },
        pagination: {
            style: {
                border: 'none',
            },
        },
    };
    const fetchData = async (page, size = perPage) => {
        setLoading(true);
        let sort = {};
        if (sortField && sortField !== "") {
            sort = {
                sortField,
                sortDirection
            };
        }
        try{
            const response = await Axios.post(apiURL, {
                page,
                size,
                filters,
                sort
            });
            setData(response.data.data);
            setTotalRows(response.data.total);
            setLoading(false);
        } catch(error) {
            console.log("ServerTable_", error)
            setLoading(false);
        }
    };
    const handlePageChange = (page) => {
        fetchData(page);
        setCurrentPage(page);
    };
    const handlePerRowsChange = async (newPerPage, page) => {
        fetchData(page, newPerPage);
        setPerPage(newPerPage);
    };
    const handleSort = async (column, sortDirection) => {
        setSortDirection(sortDirection);
        setSortField(column.selector);
    };
    useEffect(() => {
        fetchData(1);
    }, []);

    useEffect(() => {
        if (sortField && sortField !== "") {
            fetchData(1);
        }
    }, [sortDirection, sortField]);
    return (
        <div>
            <DataTable
                noHeader
                columns={columns}
                data={data}
                progressPending={loading}
                pagination={!hidePagination}
                paginationServer
                customStyles={customStyles}
                paginationTotalRows={totalRows}
                paginationDefaultPage={currentPage}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                sortServer
                highlightOnHover
                onSort={handleSort}
            />
        </div>
    )
}
export default ServerTable;


